module.exports = __webpack_public_path__ + "media/images/img_top_mv_point03-f5153f3044a7076c26cbd5451cdd80b4.png";